export default __webpack_public_path__ + "static/media/opentext.057ed9ce.jpg";